import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { useLayoutStateContext } from 'src/context/layoutState';
import { useDataContext } from 'src/context/data';
import crossIcon from '../../../../assets/cross-icon.svg';
import { modalStyles, closeButton, contentWrapper, crossIconStyles } from './style';
import SpinnerLoader from 'src/components/SpinnerLoader/SpinnerLoader';

function StyledModal() {
  const {
    appState: {
      widgetData: {
        config: { script },
      },
      currentMessageId,
    },
  } = useDataContext();

  const { wistiaVideoModalIsVisible, toggleModalIsVisible, child, isLoading, setLoading } = useLayoutStateContext();
  const currentMessageData = script[currentMessageId];

  const { wistiaMatcher } = currentMessageData;

  useEffect(() => {
    // for users of screenreaders that other page content be hidden (via the aria-hidden attribute) while the modal is open
    Modal.setAppElement(document.body);
  });

  useEffect(() => {
    setLoading(true);
  }, []);

  return (
    <Modal
      key={wistiaMatcher}
      isOpen={wistiaVideoModalIsVisible}
      style={modalStyles}
      shouldCloseOnOverlayClick
      onRequestClose={() => toggleModalIsVisible(false)}
      contentLabel="Modal"
    >
      <div style={{ position: 'absolute' }}>
        <SpinnerLoader isLoading={isLoading} />
      </div>
      <div style={isLoading ? { display: 'none' } : contentWrapper}>
        <div style={closeButton} onClick={() => toggleModalIsVisible(false)}>
          <img style={crossIconStyles} src={crossIcon} alt="Close" />
        </div>
        {child}
      </div>
    </Modal>
  );
}

export default StyledModal;
